var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41.8667,
    height: 42.3333,
    rx: 20.9333,
    stroke: "#FD5625"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2413 16.4283C12.212 14.4955 13.7011 12.8706 15.5422 11.7354C17.3832 10.6002 19.5037 9.99932 21.6667 10C24.8108 10 27.4522 11.1562 29.4717 13.0392L26.1268 16.3852C24.917 15.229 23.3793 14.6398 21.6667 14.6398C18.6275 14.6398 16.055 16.6932 15.1392 19.45C14.9058 20.15 14.7728 20.8967 14.7728 21.6667C14.7728 22.4367 14.9058 23.1833 15.1392 23.8833C16.0562 26.6413 18.6275 28.6935 21.6667 28.6935C23.2358 28.6935 24.5717 28.2793 25.617 27.5793C26.223 27.1803 26.7418 26.6626 27.1421 26.0574C27.5423 25.4522 27.8157 24.7722 27.9457 24.0583H21.6667V19.5457H32.6543C32.792 20.3087 32.8667 21.1043 32.8667 21.9315C32.8667 25.4852 31.595 28.4765 29.3877 30.5065C27.458 32.2892 24.8167 33.3333 21.6667 33.3333C20.1344 33.3339 18.617 33.0326 17.2013 32.4465C15.7856 31.8604 14.4992 31.0011 13.4157 29.9176C12.3322 28.8341 11.4729 27.5478 10.8868 26.132C10.3007 24.7163 9.99939 23.1989 10 21.6667C10 19.7837 10.4503 18.0033 11.2413 16.4283Z",
    fill: "#FD5625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.06698a3545cb45f2b77b73136c9fd1a6.svg";
export { ForwardRef as ReactComponent };